/**
 * G5 (R4): the lead figure of an article screen — the first section, in sort order, that is a `Media` section showing
 * an Image. It loads eagerly with fetchpriority high; every other template figure is lazy (ArticleFigure). Pure.
 */
export interface LeadFigureCandidate {
  id: string;
  kind: string;
  mediaContent?: unknown;
}

export function findLeadFigureSectionId(sortedSections: ReadonlyArray<LeadFigureCandidate>): string | null {
  for (const section of sortedSections) {
    if (section.kind !== 'Media') continue;
    const media = section.mediaContent as { kind?: unknown } | undefined;
    if (media?.kind === 'Image') return section.id;
  }
  return null;
}
